import { render, staticRenderFns } from "./CoAssigneeAvatars.vue?vue&type=template&id=7425715e&scoped=true&"
import script from "./CoAssigneeAvatars.vue?vue&type=script&lang=js&"
export * from "./CoAssigneeAvatars.vue?vue&type=script&lang=js&"
import style0 from "./CoAssigneeAvatars.vue?vue&type=style&index=0&id=7425715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7425715e",
  null
  
)

export default component.exports